import { render, staticRenderFns } from "./MesecnaPretplataForma.vue?vue&type=template&id=036a0e4f&"
import script from "./MesecnaPretplataForma.vue?vue&type=script&lang=js&"
export * from "./MesecnaPretplataForma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports